<template>
	<div class="content row-flex-start" style="min-width:1500px;ovorflow-x:auto">
		<div class="left_map" ref="mapBox" :style="{ width: videoBox.width + 'px' }"></div>
		<el-button v-if="showBack" class="close_echarts" type="primary" icon="el-icon-arrow-left" @click="showChinaMap">
			返回</el-button>
		<div v-if="showdetail"
			style="display:flex;flex-direction: row;padding:10px 10px;box-sizing: border-box;position: absolute;right: 20px;top: 120px;background-color: rgba(50,50,50,0.7);border-radius: 4px;">
			<img style="height:142px;width:142px;margin-right:10px;"
				src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1600775559810&di=193b49425c821dd33b37b6da85f65961&imgtype=0&src=http%3A%2F%2Fpic29.nipic.com%2F20130503%2F12529205_152323589109_2.jpg"
				alt="" />
			<div style="display:flex;flex-direction: column;color:#fff;width:430px;font-size:16px;">
				<div style="font-size:20px;margin-top:10px;">公司总部</div>
				<div style="margin:6px 0">
					地址：南京市中山路300号长发中心2号楼7楼E座
				</div>
				<div style="display: flex; flex-direction: row; justify-content: space-between;">
					<span>总机：025-86988866</span>
					<span>邮编：210002</span>
				</div>
				<div style="display: flex; flex-direction: row; justify-content: space-between;margin:4px 0">
					<span>传真：025-86988866/86988866</span>
					<span>联系人：张某某</span>
				</div>
				<div>邮箱：admin@js-chinaarts.com</div>
			</div>
		</div>
	</div>
</template>

<script>
	import echarts from "echarts";
	import china from "echarts/map/json/china.json";

	import {
		request
	} from "../../utils/http";
	echarts.registerMap("china", china);
	var provinces = [
		"shanghai",
		"hebei",
		"shanxi",
		"neimenggu",
		"liaoning",
		"jilin",
		"heilongjiang",
		"jiangsu",
		"zhejiang",
		"anhui",
		"fujian",
		"jiangxi",
		"shandong",
		"henan",
		"hubei",
		"hunan",
		"guangdong",
		"guangxi",
		"hainan",
		"sichuan",
		"guizhou",
		"yunnan",
		"xizang",
		"shanxi1",
		"gansu",
		"qinghai",
		"ningxia",
		"xinjiang",
		"beijing",
		"tianjin",
		"chongqing",
		"xianggang",
		"aomen",
		"taiwan",
	];
	var provincesText = [
		"上海",
		"河北",
		"山西",
		"内蒙古",
		"辽宁",
		"吉林",
		"黑龙江",
		"江苏",
		"浙江",
		"安徽",
		"福建",
		"江西",
		"山东",
		"河南",
		"湖北",
		"湖南",
		"广东",
		"广西",
		"海南",
		"四川",
		"贵州",
		"云南",
		"西藏",
		"陕西",
		"甘肃",
		"青海",
		"宁夏",
		"新疆",
		"北京",
		"天津",
		"重庆",
		"香港",
		"澳门",
		"台湾",
	];
	export default {
		created() {
			this.videoBox.width = document.body.clientWidth;

			// this.cityOpt = 'china';
		},
		mounted() {
			var _this = this;
			this.startInitMap();
		},
		data() {
			return {
				showBack: false, //返回按钮是否显示
				map: {},
				cityOpt: [],
				mapForm: {},
				mapOpt: [],
				videoBox: {
					width: "100%",
				},
				showdetail: false,
				gaoliang:null
			};
		},
		computed: {},
		props: {},
		methods: {
			startInitMap() {
				this.$nextTick(() => {
					this.$http.post("/webpc/pccompanymaillist/companylist").then((res) => {
						let list = res.data.detail;
						list.forEach((item) => {
							item.name = item.comapanyprovince;
							item.value = item.count;
						});
						console.log(list)
						this.showBack = false;
						this.initMap(list);
					});
				});
			},
			//中国地图
			randomData() {
				return Math.round(Math.random() * 500);
			},
			chinaShowLogoPosition(place, list, data) {
				let temp = []; //需要地图标点的地方
				let arr = []; //临时的所有位置数组
				//中国地图有数据需要展示坐标点的
				if (place == "china") {
					if (china && china.features && Array.isArray(china.features)) {
						arr = china.features;
					}
				} else {
					if (data && data.features && Array.isArray(data.features)) {
						arr = data.features;
					}
				}
				if (arr && arr.length > 0) {
					arr.forEach((element) => {
						if (list && Array.isArray(list)) {
							list.forEach((item) => {
								if (item.name == element.properties.name) {
									temp.push({
										name: element.properties.name,
										value: [
											element.properties.cp[0],
											element.properties.cp[1],
											item,
											item.value || 1,
										],
									});
								}
							});
						}
					});
				}

				return temp;
			},
			convertData(data, showPosition) {
				var res = [];
				for (var i = 0; i < data.length; i++) {
					var geoCoord = showPosition[data[i].name];
					if (geoCoord) {
						res.push({
							name: data[i].name,
							value: geoCoord.concat(data[i].value),
						});
					}
				}
				return res;
			},
			getMapOpt(place, list, data) {
				let _this = this;
				let showPosition = _this.chinaShowLogoPosition(place, list, data);
				showPosition.forEach((item) => {
					if (item && Array.isArray(item.value)) {
						item.value[1] && (item.value[1] += 0.1);
						item.value[0] && (item.value[0] += 0.05);
					}
				});
				if(showPosition.length == 0){
					showPosition = [
						{ name: '江苏', value: 100 },						
					]
				}else{
					var flag = 0;
					showPosition.forEach(item=>{
					    if(item.name=='江苏'){
							flag = 1;
					    }
					})
					if(flag == 0){
						showPosition.push({ name: '江苏', value: 100 });
					}
				}
				this.gaoliang=showPosition;
				//展示地图
				let option = (option = {
					title: {
						// text: "全国地图大数据",
						subtext: "",
						x: "center",
					},
					backgroundColor: "#404a59",
					tooltip: {
						trigger: "item",
						//formatter: "名称:{a}<br />坐标:{c}"
						formatter: function(params) {
							var res = "";
							if (place == "china") {
								res = params.name;
								//   (params.name ? params.name + ":" : "") +
								//   (params.data && params.data.value
								//     ? params.data.value[3]
								//     : "0") +
								//   "<br/>";
								// (params.name ? params.name + ":" : "") +
								//   (params.value ? params.value[3] : "0") +
								//   "<br/>";
								return res;
							} else if (
								params.data &&
								params.data.value &&
								params.data.value[2]
							) {
								let data = params.data.value[2];
								//    <div style='font-size:20px;margin-top:10px;'>公司总部</div>

								res = `<div style='display:flex;flex-direction: row;padding:10px 10px;box-sizing: border-box;right: 20px !important;top: 120px !important;'>
                <img style='height:142px;width:142px;margin-right:10px;' src="${data.showpath}" alt="">
                <div style='display:flex;flex-direction: column;color:#fff;width:430px;font-size:16px;padding-right:20px;'>
                  <div style='margin:6px 0;text-overflow: -o-ellipsis-lastline;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;    white-space: normal;'>地址：${data.companyarea}</div>
                  <div style='display: flex; flex-direction: row; justify-content: space-between;'>
                    <span style="display: inline-block;width: 130px;">总机：${data.cophone}</span>
                    <span  style="display: inline-block;width: 130px;">邮编：${data.zipcode}</span>
                  </div>
                  <div style='display: flex; flex-direction: row; justify-content: space-between;margin:4px 0'>
                    <span style="display: inline-block;width: 130px;">传真：${data.cofaxphone}</span>
                    <span style="display: inline-block;width: 130px;">联系人：${data.coperson}</span>
                  </div>
                  <div>邮箱：${data.email}</div>
                </div>
              </div>`;
							} else {}
							(params.name ? params.name + ":" : "") +
							(params.value ? params.value[2] : "0") +
							"<br/>";
							return res;
						},
					},
					dataRange: {
						show: false,
						x: "left",
						y: "center",
						splitList: place == "china" ?
							[{
									start: 0,
									end: 1,
									color: "rgb(204,204,204)",
								},
								{
									start: 1,
									end: 20,
									color: "red",
								},
								{
									start: 20,
									end: 30,
									color: "blue",
								},
								{
									start: 30,
									end: 40,
									color: "green",
								},
								{ start: 100, end: 100, color: '#029dee' },
							] :
							[{
								start: 0,
								color: "#40eEFF",
							}, ],
						selectedMode: false,
					},
					series: [{
						type: "map",
						map: place,
						roam: false,
						showLegendSymbol: false, // 存在legend时显示
						label: {
							normal: {
								show: false,
							},
							emphasis: {
								show: false,
								textStyle: {
									color: "#fff",
								},
							},
						},
						coordinateSystem: "geo",
						label: {
							normal: {
								show: true,
								textStyle: {
									color: "#fff",
									fontSize: 12,
								},
								formatter(value) {
									return value.name;
								},
							},
						},
						itemStyle: {
							normal: {
								areaColor: "#666",
								shadowColor: "#666",
								shadowOffsetX: 0,
								textStyle: {
									color: "#fff",
								},
								// shadowOffsetY: 25,
							},
							emphasis: {
								areaColor: "#029dee",
								borderWidth: 0,
								color: "green",
								label: {
									show: false,
								},
							},
						},
						data: this.gaoliang,
					}, ],
				});
				return option;
			},
			//显示中国地图
			showChinaMap() {
				
				this.startInitMap();
			},
			//显示各省地图
			getProvinceMapOpt(provinceAlphabet, name) {
				this.$http
					.get(`/webpc/pccompanymaillist/companylist?companyarea=${name}`)
					.then((resList) => {
						var list = resList.data.detail;
						request({
							url: "/province/" + provinceAlphabet + ".json",
						}).then((res) => {
							console.log(res.data.features)
							let cityList = [];
							res.data.features.forEach((cityItem) => {
								//循环push所有城市
								cityList.push(cityItem.properties.name);
							});
							this.showBack = true;
							echarts.registerMap(provinceAlphabet, res.data);

							list.forEach((listItem) => {
								//返回列表循环
								cityList.forEach((cityListItem) => {
									if ((listItem.companyarea + "").indexOf(cityListItem) > -
										1) {
										listItem.name = cityListItem;
									}
								});
							});
							let option = this.getMapOpt(provinceAlphabet, list, res.data);
							this.map.setOption(option, true);
						});
					});

				// });
			},
			yichu() {
				this.showdetail = false;
			},
			initMap(list) {
				var dom = this.$refs.mapBox;
				this.map = echarts.init(dom);
				let option = this.getMapOpt("china", list);
				if (option && typeof option === "object") {
					this.map.setOption(option, true);
				}
				this.map.on("click", (param) => {
					if (param.data) {
						event.stopPropagation(); // 阻止冒泡
						// 找到省份名
						let provinceIndex = provincesText.findIndex((x) => {
							return param.name === x;
						});
						if (provinceIndex === -1) return;
						let provinceAlphabet = provinces[provinceIndex];
						// 重新渲染各省份地图
						this.getProvinceMapOpt(provinceAlphabet, param.name);
					}
				});
			},
		},
	};
</script>

<style>
	.content {
		width: 100%;
		height: 100%;
	}

	.left_map {
		width: 1200px;
		height: 800px;
	}

	.close_echarts {
		position: absolute;
		right: 160px;
		top: 60px;
	}
</style>
